import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import LegalDoc from "../components/LegalDoc";
import PRIVACY from "../content/privacy";

export default function Privacy() {
  return (
    <div className="px-4 py-6 pb-24" data-testid="privacy-page">
      <div className="flex items-center gap-3 mb-6">
        <Link to="/settings" data-testid="privacy-back"><ArrowLeft className="w-5 h-5"/></Link>
        <h1 className="font-outfit font-extrabold text-2xl tracking-tighter">Privacy Policy</h1>
      </div>
      <LegalDoc text={PRIVACY}/>
    </div>
  );
}
